var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMissionLandscapeinline = function SvgMissionLandscapeinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Summer Landscape"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M40.083 28.979h2.167v11.767a.394.394 0 0 1-.361.42h-1.445a.394.394 0 0 1-.36-.42V28.98Z",
    fill: "#092140"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M45.284 30.197a2.425 2.425 0 0 0-2.256-4.12 1.894 1.894 0 0 0-1.861-2.26 1.897 1.897 0 0 0-1.861 2.26 2.43 2.43 0 0 0-2.257 4.12 2.7 2.7 0 0 0 1.99 4.945 2.163 2.163 0 0 0 4.224-.009 2.7 2.7 0 0 0 2.021-4.936Z",
    fill: "#1C385E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M34.535 40.896h-18.04a1.248 1.248 0 0 1-1.1-1.776l9.023-19.983a1.196 1.196 0 0 1 2.194 0l9.024 19.983a1.248 1.248 0 0 1-1.101 1.776Z",
    fill: "#F12B3B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M27.997 40.896H4.813a1.608 1.608 0 0 1-1.416-2.287l9.07-20.133 2.53-5.63a1.532 1.532 0 0 1 2.816 0l2.585 5.742 9.015 20.02a1.606 1.606 0 0 1-1.416 2.288Z",
    fill: "#1C385E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M29.25 41.708a23.518 23.518 0 0 1 4.016 3.792h13.317a2.166 2.166 0 0 0 2.167-2.167v-1.428a1.08 1.08 0 0 0-.686-1.009A22.011 22.011 0 0 0 40.166 39a23.18 23.18 0 0 0-10.916 2.708Z",
    fill: "#092140"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M34.261 41.235a30.192 30.192 0 0 0-17.506-5.485 30.602 30.602 0 0 0-12.883 2.953 1.087 1.087 0 0 0-.622.988v3.642A2.167 2.167 0 0 0 5.417 45.5H39a27.287 27.287 0 0 0-4.739-4.265Z",
    fill: "#092140"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M34.667 8.666a4.333 4.333 0 1 0 0 8.667 4.333 4.333 0 0 0 0-8.666Z",
    fill: "#F12B3B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M40.083 29.25a1.083 1.083 0 1 0 0-2.167 1.083 1.083 0 0 0 0 2.167Z",
    fill: "#F12B3B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M43.333 32.5a1.083 1.083 0 1 0 0-2.167 1.083 1.083 0 0 0 0 2.167Z",
    fill: "#F12B3B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M39 33.583a1.083 1.083 0 1 0 0-2.167 1.083 1.083 0 0 0 0 2.167Z",
    fill: "#F12B3B"
  }))));
};
export default SvgMissionLandscapeinline;